import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcDate',
  standalone: true
})
export class UtcDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format: 'short' | 'long' = 'long'): string {
    if (!value) return '';
    
    // Convert to string if it's a Date object
    const dateStr = typeof value === 'string' ? value : value.toISOString();
    
    // Extract date part (YYYY-MM-DD) from ISO string
    const [datePart] = dateStr.split('T');
    const [year, month, day] = datePart.split('-');
    
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    if (format === 'short') {
      return `${day}/${month}/${year}`;
    }
    
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  }
}